// extracted by mini-css-extract-plugin
export default {"container":"Shows_container__FYhXe","inner":"Shows_inner__tazuM","title":"Shows_title__9zZLA","innerMobile":"Shows_innerMobile__rgP4H","titleMobile":"Shows_titleMobile__0FdMc"};